function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import CGAlgorithmsDD from './CGAlgorithmsDD';
var Orientation = /*#__PURE__*/function () {
  function Orientation() {
    _classCallCheck(this, Orientation);
    Orientation.constructor_.apply(this, arguments);
  }
  return _createClass(Orientation, [{
    key: "getClass",
    value: function getClass() {
      return Orientation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "index",
    value: function index(p1, p2, q) {
      return CGAlgorithmsDD.orientationIndex(p1, p2, q);
    }
  }, {
    key: "isCCW",
    value: function isCCW(ring) {
      var nPts = ring.length - 1;
      if (nPts < 3) throw new IllegalArgumentException('Ring has fewer than 4 points, so orientation cannot be determined');
      var hiPt = ring[0];
      var hiIndex = 0;
      for (var i = 1; i <= nPts; i++) {
        var p = ring[i];
        if (p.y > hiPt.y) {
          hiPt = p;
          hiIndex = i;
        }
      }
      var iPrev = hiIndex;
      do {
        iPrev = iPrev - 1;
        if (iPrev < 0) iPrev = nPts;
      } while (ring[iPrev].equals2D(hiPt) && iPrev !== hiIndex);
      var iNext = hiIndex;
      do {
        iNext = (iNext + 1) % nPts;
      } while (ring[iNext].equals2D(hiPt) && iNext !== hiIndex);
      var prev = ring[iPrev];
      var next = ring[iNext];
      if (prev.equals2D(hiPt) || next.equals2D(hiPt) || prev.equals2D(next)) return false;
      var disc = Orientation.index(prev, hiPt, next);
      var isCCW = null;
      if (disc === 0) {
        isCCW = prev.x > next.x;
      } else {
        isCCW = disc > 0;
      }
      return isCCW;
    }
  }]);
}();
export { Orientation as default };
Orientation.constructor_ = function () {};
Orientation.CLOCKWISE = -1;
Orientation.RIGHT = Orientation.CLOCKWISE;
Orientation.COUNTERCLOCKWISE = 1;
Orientation.LEFT = Orientation.COUNTERCLOCKWISE;
Orientation.COLLINEAR = 0;
Orientation.STRAIGHT = Orientation.COLLINEAR;